import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

const Footer = ({ items }) => (
  <footer className="footer">
    <div className="container">
      <div className="footer-content">
        <div className="row row--wrap">
          <div className="col-xs-12 col-md-4">
            <Link to="/" className="logo">
              <span className="logo-item">dom</span>
              {' Yalta'}
            </Link>
          </div>
          <div className="col-xs-6 col-md-2">
            <ul className="footer-list">
              <li className="footer-item">
                <Link to="/" className="footer-link">
                  Главная
                </Link>
              </li>
              <li className="footer-item">
                <Link to="/about" className="footer-link">
                  О Нас
                </Link>
              </li>
              <li className="footer-item">
                <Link to="/faq" className="footer-link">
                  Вопросы
                </Link>
              </li>
              <li className="footer-item">
                <Link to="/reviews" className="footer-link">
                  Отзывы
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-xs-6 col-md-2">
            <ul className="footer-list">
              <li className="footer-item">Контакты:</li>
              <li className="footer-item">
                <a href={`mailto:${items.email}`} className="footer-link">
                  {items.email}
                </a>
              </li>
              <li className="footer-item">
                <a href={`tel:${items.phone}`} className="footer-link">
                  {items.phone}
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xs-6 col-md-2">
            <ul className="footer-list footer-social">
              <li className="footer-item">
                <a
                  href={items.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  <span className="footer-icon instagram" />
                </a>
              </li>
              <li className="footer-item">
                <a
                  href={items.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  <span className="footer-icon facebook" />
                </a>
              </li>
              <li className="footer-item">
                <a
                  href={items.vk}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  <span className="footer-icon vk" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-copyright">All rights reserved DOM_YALTA &copy;2019</div>
    </div>
  </footer>
);

Footer.propTypes = {
  items: PropTypes.shape({
    instagram: PropTypes.string.isRequired,
    facebook: PropTypes.string.isRequired,
    vk: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  }).isRequired,
};

export default Footer;
